/* Tattoo Golf Help Center — client-side search, filter, accordion, theme, dialog */
(function () {
  'use strict';

  const root = document.getElementById('tg-help-center');
  if (!root || root.dataset.tgReady === 'true') return;
  root.dataset.tgReady = 'true';

  // ---------- Categories ----------
  const CATEGORIES = [
    { id: 'orders',    label: 'Orders & Shipping',     blurb: 'Free shipping threshold, methods, delivery estimates, tracking, FedEx 2-Day weekend rule, international customs.',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7h13l5 5v5h-2"/><path d="M3 7v10h2"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>' },
    { id: 'returns',   label: 'Returns & Exchanges',   blurb: '60-day return window, how to start a return, exchanges, refund timing, defective items, return address.',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>' },
    { id: 'size',      label: 'Size & Fit',            blurb: "Men's shirt and shorts charts, women's sizing help, how to choose a size.",
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8h18M3 12h18M3 16h18"/><path d="M7 6v4M12 6v4M17 6v4"/></svg>' },
    { id: 'product',   label: 'Product & Care',        blurb: 'Cool-Stretch performance fabric, materials, what makes a Tattoo Golf piece a Tattoo Golf piece.',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7l4-4h8l4 4-3 3v10H7V10z"/><path d="M9 3v2a3 3 0 0 0 6 0V3"/></svg>' },
    { id: 'account',   label: 'Account & Rewards',     blurb: 'Logging in, order history, rewards, points, gift cards — what we can confirm today.',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>' },
    { id: 'wholesale', label: 'Wholesale & Retail',    blurb: 'Carrying Tattoo Golf in your shop, pro shop or team store.',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7h18l-2 12H5z"/><path d="M8 7V5a4 4 0 0 1 8 0v2"/></svg>' },
    { id: 'privacy',   label: 'Privacy & Policies',    blurb: 'Privacy, cookies, terms, hCaptcha, payment accuracy.',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5z"/></svg>' },
    { id: 'contact',   label: 'Contact Support',       blurb: 'Email, phone, address, hours, and contact form.',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"/><path d="M3.5 20.5 7 17"/></svg>' },
  ];

  // ---------- Articles ----------
  // Each article: id, cat, title, summary, body (HTML string), related[] (label + href, external?)
  const SRC = {
    shippingInfo: 'https://tattoogolf.com/pages/shipping-info',
    shippingPolicy: 'https://tattoogolf.com/policies/shipping-policy',
    returns: 'https://tattoogolf.com/pages/returns',
    refund: 'https://tattoogolf.com/policies/refund-policy',
    contact: 'https://tattoogolf.com/pages/contact',
    size: 'https://tattoogolf.com/size-chart/',
    privacy: 'https://tattoogolf.com/policies/privacy-policy',
    terms: 'https://tattoogolf.com/policies/terms-of-service',
  };

  const ARTICLES = [
    {
      id: 'free-shipping',
      cat: 'orders',
      title: 'Do you offer free shipping?',
      summary: 'Yes — free shipping on U.S. orders of $30 or more, across the entire store. No hidden fees.',
      body: `
        <p>Free shipping applies to <strong>all Tattoo Golf orders of $30 or more</strong> shipped within the USA — a new golf shirt, hat, belt, or any of our signature gear all qualify once your cart hits the threshold.</p>
        <ul>
          <li><strong>Where:</strong> All 50 states, U.S. military bases, and U.S. territories.</li>
          <li><strong>Order minimum:</strong> $30 or more, storewide.</li>
          <li><strong>International orders:</strong> Not eligible for free shipping at this time.</li>
          <li><strong>Hidden fees:</strong> None.</li>
        </ul>`,
      related: [
        { label: 'Shipping Info page', href: SRC.shippingInfo, ext: true },
        { label: 'Shipping policy', href: SRC.shippingPolicy, ext: true },
        { label: 'Shipping methods & delivery times', href: '#a-methods' },
      ],
    },
    {
      id: 'a-methods',
      cat: 'orders',
      title: 'What shipping methods do you offer and how fast are they?',
      summary: 'USPS Ground Advantage, USPS Priority, FedEx 2-Day, and FedEx Overnight for U.S. orders.',
      body: `
        <p>Pick your speed at checkout. Estimated delivery windows are business days, not calendar days.</p>
        <div class="tbl-wrap"><table class="tbl">
          <thead><tr><th>Method</th><th>Geography</th><th>Estimated delivery</th></tr></thead>
          <tbody>
            <tr><td>USPS Ground Advantage</td><td>Domestic</td><td>3–5 business days</td></tr>
            <tr><td>USPS Priority</td><td>Domestic</td><td>2–3 business days</td></tr>
            <tr><td>FedEx 2-Day</td><td>Domestic</td><td>2-day delivery (does <em>not</em> include weekends)</td></tr>
            <tr><td>FedEx Overnight</td><td>Domestic</td><td>Overnight</td></tr>
            <tr><td>International</td><td>International</td><td>Varies by destination</td></tr>
          </tbody>
        </table></div>
        <p>Need it faster than FedEx Overnight or on a weekend? See the <a href="#a-saturday">Saturday delivery</a> article.</p>`,
      related: [
        { label: 'Shipping Info', href: SRC.shippingInfo, ext: true },
        { label: 'FedEx 2-Day weekend rule', href: '#a-saturday' },
      ],
    },
    {
      id: 'a-tracking',
      cat: 'orders',
      title: 'Will I get a tracking number?',
      summary: 'Yes. Tracking numbers are included on every Tattoo Golf order.',
      body: `
        <p>We include a <strong>tracking number on every order</strong>, regardless of shipping method. You'll receive it by email once your order leaves our Burbank, CA warehouse.</p>
        <ul>
          <li>Check your inbox (and spam folder) for the shipping confirmation.</li>
          <li>Tracking links come from USPS or FedEx depending on the method you chose.</li>
          <li>Lost the email? Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> with your order number and we'll resend it.</li>
        </ul>`,
      related: [
        { label: 'Shipping Info', href: SRC.shippingInfo, ext: true },
        { label: 'Contact support', href: '#contact' },
      ],
    },
    {
      id: 'a-saturday',
      cat: 'orders',
      title: 'Does FedEx 2-Day include Saturday? Can I get weekend delivery?',
      summary: 'FedEx 2-Day does not count weekends. For Saturday delivery, email sales@tattoogolf.com — extra charges may apply.',
      body: `
        <p>FedEx 2-Day is two <em>business</em> days. Saturday and Sunday are not counted in the standard delivery window.</p>
        <ul>
          <li>Example: an order shipped <strong>Thursday</strong> with FedEx 2-Day arrives <strong>Monday</strong>, because Saturday and Sunday are skipped.</li>
          <li>If you need <strong>Saturday delivery</strong>, contact <a href="mailto:sales@tattoogolf.com">sales@tattoogolf.com</a> before placing the order so we can arrange it.</li>
          <li>Additional charges may apply for Saturday delivery.</li>
        </ul>`,
      related: [
        { label: 'Shipping Info', href: SRC.shippingInfo, ext: true },
        { label: 'Shipping methods', href: '#a-methods' },
      ],
    },
    {
      id: 'a-international',
      cat: 'orders',
      title: 'Do you ship internationally? What about customs and duties?',
      summary: 'Yes, we ship internationally. Customs fees, duties, and import taxes are the recipient’s responsibility.',
      body: `
        <p>We ship Tattoo Golf gear worldwide, but a few things work differently outside the U.S.:</p>
        <ul>
          <li><strong>Free shipping does not apply</strong> to international orders.</li>
          <li><strong>Delivery times vary</strong> based on the destination country.</li>
          <li><strong>Customs fees, import duties, taxes, and any additional charges are the sole responsibility of the recipient.</strong> They must be paid by the recipient.</li>
          <li>Release of packages is at the <strong>discretion of local customs authorities</strong>. Customs agents may delay delivery for inspection or other reasons beyond our control.</li>
          <li>We <strong>cannot predict or influence</strong> the customs process or the fees applied to your country.</li>
        </ul>
        <p>If a package is held by customs, contact your local customs office first — they're the only ones who can release it.</p>`,
      related: [
        { label: 'Shipping Info', href: SRC.shippingInfo, ext: true },
        { label: 'Shipping policy', href: SRC.shippingPolicy, ext: true },
      ],
    },
    {
      id: 'a-where-ship',
      cat: 'orders',
      title: 'Where do you ship domestically?',
      summary: 'All 50 states, U.S. military bases, and U.S. territories.',
      body: `
        <p>We ship to <strong>all 50 states, U.S. military bases, and U.S. territories</strong>. Free shipping kicks in at $30, no hidden fees.</p>
        <ul>
          <li>APO/FPO/DPO military addresses are supported — choose USPS at checkout for the most reliable delivery.</li>
        </ul>`,
      related: [{ label: 'Shipping Info', href: SRC.shippingInfo, ext: true }],
    },
    {
      id: 'a-order-status',
      cat: 'orders',
      title: 'How do I check my order status?',
      summary: 'Log in and open “Complete Orders” under My Account, or check your shipping email for tracking.',
      body: `
        <p>Two ways:</p>
        <ol>
          <li><strong>Log in</strong> to your account on tattoogolf.com and open the <code>Complete Orders</code> section under the <code>My Account</code> menu. You'll see your order history and tracking.</li>
          <li><strong>Check your email</strong> for the shipping confirmation — it includes a direct tracking link.</li>
        </ol>
        <p>Still stuck? Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> with your order number.</p>`,
      related: [{ label: 'Contact support', href: '#contact' }],
    },

    // RETURNS
    {
      id: 'a-return-window',
      cat: 'returns',
      title: 'What is your return window?',
      summary: '60 days from delivery for a full refund on new, unused items with original tags. Late returns get store credit.',
      body: `
        <p>You may return <strong>new, unused items with the original tags attached</strong> within <strong>60 days of delivery</strong> for a full refund.</p>
        <ul>
          <li><strong>Items returned after the 60-day window</strong> are not eligible for a refund — instead, store credit will be issued for future purchases.</li>
          <li>The 60-day clock starts the day your order is delivered.</li>
        </ul>
        <div class="callout-internal" role="note"><strong>Heads up — there's a published policy mismatch.</strong> The <a href="${SRC.refund}" target="_blank" rel="noopener noreferrer">Refund Policy page</a> currently says 30 days, while the <a href="${SRC.returns}" target="_blank" rel="noopener noreferrer">Returns page</a> says 60 days. See the <a href="#a-policy-cleanup">Refund policy vs. returns page</a> article.</div>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'How to start a return', href: '#a-start-return' },
        { label: 'Refunds timing', href: '#a-refund-timing' },
      ],
    },
    {
      id: 'a-start-return',
      cat: 'returns',
      title: 'How do I start a return?',
      summary: 'Log in, open Complete Orders, pick the item, then mail it to our Burbank address with a note that has your order number and instructions.',
      body: `
        <ol>
          <li><strong>Log in to your account</strong> on tattoogolf.com.</li>
          <li>Open the <code>Complete Orders</code> section under the <code>My Account</code> menu.</li>
          <li>Find the order and click <strong>Return Item(s)</strong> next to the item.</li>
          <li>Pack the item — new, unused, original tags attached.</li>
          <li>Include a note with your <strong>original order number</strong> and clear instructions: refund or exchange.</li>
          <li>Mail it to: <strong>Tattoo Golf, 2829 N. Glenoaks Blvd., Suite 103, Burbank, CA 91504</strong>.</li>
        </ol>
        <p>Once we receive it, we'll email a confirmation that your return is being processed.</p>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'Return address', href: '#a-return-address' },
        { label: 'Exchange instructions', href: '#a-exchange' },
      ],
    },
    {
      id: 'a-exchange',
      cat: 'returns',
      title: 'How do exchanges work? (different size or color)',
      summary: 'Mail the item back with a note specifying the new size, color, or product. Replacements ship within five business days, often faster.',
      body: `
        <p>If you need a different size, color, or product:</p>
        <ul>
          <li>Include a note with your <strong>original order number</strong> and <strong>specify the new size, color, or item</strong> you want.</li>
          <li>We'll send your replacement within <strong>five business days</strong> of receiving your return — usually faster.</li>
          <li>Item must be new, unused, with the original tags attached.</li>
        </ul>
        <p>The more specific your note, the faster we can ship the swap.</p>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'How to start a return', href: '#a-start-return' },
      ],
    },
    {
      id: 'a-refund-timing',
      cat: 'returns',
      title: 'When will my refund hit?',
      summary: 'Refunds are issued within five business days of us receiving your return.',
      body: `
        <p>Your refund will be issued <strong>within five business days of us receiving the returned item</strong>. After that, your bank or card issuer may take a few extra days to post the credit.</p>
        <ul>
          <li>Refunds go back to the original payment method.</li>
          <li>We'll send an email confirmation when your return has been processed.</li>
        </ul>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'How to start a return', href: '#a-start-return' },
      ],
    },
    {
      id: 'a-defective',
      cat: 'returns',
      title: 'I received a defective or incorrect item — what now?',
      summary: 'Contact us immediately and we will make it right. If the mistake is ours, we cover return shipping.',
      body: `
        <p>Inspect your order on arrival. If the item is <strong>defective, damaged, or you received the wrong item</strong>, contact us immediately and we'll evaluate the issue and make it right.</p>
        <ul>
          <li>Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> with your order number, a description of the issue, and photos if possible.</li>
          <li>If the return is due to an error on our part — incorrect or defective item — <strong>we'll cover the return shipping costs.</strong></li>
        </ul>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'Contact support', href: '#contact' },
      ],
    },
    {
      id: 'a-sale-items',
      cat: 'returns',
      title: 'Are sale items and gift certificates returnable?',
      summary: 'Sale Rack items can only receive store credit. Gift certificates are not returnable.',
      body: `
        <p>Two exceptions to the standard return policy:</p>
        <ul>
          <li><strong>Sales Rack purchases:</strong> only <strong>store credit</strong> is offered — refunds are not available for these discounted items.</li>
          <li><strong>Gift certificates:</strong> no returns accepted.</li>
        </ul>
        <p>Everything else falls under the standard 60-day return window.</p>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'Refund policy page', href: SRC.refund, ext: true },
      ],
    },
    {
      id: 'a-return-address',
      cat: 'returns',
      title: 'Where do I mail my return?',
      summary: 'Tattoo Golf, 2829 N. Glenoaks Blvd., Suite 103, Burbank, CA 91504. Include your order number and instructions.',
      body: `
        <p>Send all returns to:</p>
        <p><strong>Tattoo Golf</strong><br>2829 N. Glenoaks Blvd., Suite 103<br>Burbank, CA 91504</p>
        <p>Always include a note with:</p>
        <ul>
          <li>Your <strong>original order number</strong></li>
          <li>Clear instructions: <strong>refund or exchange</strong> (and if it's an exchange, the new size/color/item)</li>
        </ul>
        <p>We recommend using a trackable shipping method so your package isn't lost in transit.</p>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'How to start a return', href: '#a-start-return' },
      ],
    },
    {
      id: 'a-policy-cleanup',
      cat: 'returns',
      title: 'Refund policy vs. returns page — which is right?',
      summary: 'The Returns page is our most current customer-facing policy: 60-day window with five-business-day refund processing.',
      body: `
        <p>If you're comparing the two policy pages, you've spotted a real inconsistency in our published wording:</p>
        <ul>
          <li>The <a href="${SRC.returns}" target="_blank" rel="noopener noreferrer">Returns page</a> says <strong>60 days</strong> from delivery with refunds processed within five business days.</li>
          <li>The older <a href="${SRC.refund}" target="_blank" rel="noopener noreferrer">Refund Policy page</a> says <strong>30 days</strong>.</li>
        </ul>
        <p>For now, use the <strong>60-day Returns page</strong> as the source of truth — that's what our support team operates on. Sale Rack and gift certificate exceptions still apply.</p>
        <div class="callout-internal" role="note"><strong>Policy cleanup needed.</strong> The public Refund Policy page should be aligned with the Returns page before this Help Center is published externally, so customers don't see conflicting terms.</div>`,
      related: [
        { label: 'Returns page', href: SRC.returns, ext: true },
        { label: 'Refund policy', href: SRC.refund, ext: true },
      ],
    },

    // SIZE
    {
      id: 'a-choose-size',
      cat: 'size',
      title: 'How do I choose the right shirt size?',
      summary: 'Measure your chest with a soft tape, then match it to our chart. If you’re between sizes, size up for a relaxed fit.',
      body: `
        <p>Our Cool-Stretch shirts have a bit of give in every direction, so most customers wear their normal size. To dial it in:</p>
        <ol>
          <li>Wrap a soft tape measure around the fullest part of your chest, under your armpits, keeping the tape level.</li>
          <li>Match the number to the chest column on the size chart.</li>
          <li>Between sizes? Size up for a relaxed fit, size down for a slimmer cut.</li>
        </ol>
        <p>Still not sure? Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> — our team is happy to help.</p>`,
      related: [
        { label: "Men's shirt chart", href: '#a-men-shirts' },
        { label: "Men's shorts chart", href: '#a-men-shorts' },
        { label: 'Size chart page', href: SRC.size, ext: true },
      ],
    },
    {
      id: 'a-men-shirts',
      cat: 'size',
      title: "Men's shirt size chart",
      summary: 'Chest, body length, and sleeve length in inches for sizes S–4XL.',
      body: `
        <p>All measurements in inches. Chest variance is ±1".</p>
        <div class="tbl-wrap"><table class="tbl">
          <thead><tr><th>Size</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th></tr></thead>
          <tbody>
            <tr><td>Chest (±1")</td><td>41.5</td><td>43.5</td><td>46</td><td>48</td><td>50</td><td>52</td><td>54</td></tr>
            <tr><td>Body length*</td><td>28.5</td><td>29.5</td><td>30.5</td><td>31.5</td><td>32.5</td><td>33.5</td><td>34.5</td></tr>
            <tr><td>Sleeve length</td><td>7.5</td><td>8.0</td><td>8.5</td><td>9.0</td><td>9.5</td><td>10.0</td><td>10.5</td></tr>
          </tbody>
        </table></div>
        <p class="muted">*Measured from the highest point of the shoulder.</p>`,
      related: [
        { label: 'Size chart page', href: SRC.size, ext: true },
        { label: 'How to choose a size', href: '#a-choose-size' },
      ],
    },
    {
      id: 'a-men-shorts',
      cat: 'size',
      title: "Men's shorts size chart",
      summary: 'Inseam and outer seam values for waist sizes 30–44. Some cells aren’t listed yet.',
      body: `
        <p>All measurements in inches. Outer seam* runs from top of waistband to bottom of leg.</p>
        <div class="tbl-wrap"><table class="tbl">
          <thead><tr><th>Waist</th><th>30</th><th>32</th><th>34</th><th>36</th><th>38</th><th>40</th><th>42</th><th>44</th></tr></thead>
          <tbody>
            <tr><td>Inseam</td><td>10.25</td><td>11</td><td>Not listed</td><td>Not listed</td><td>Not listed</td><td>Not listed</td><td>Not listed</td><td>Not listed</td></tr>
            <tr><td>Outer seam*</td><td>20.5</td><td>21.0</td><td>21.5</td><td>22.0</td><td>22.5</td><td>Not listed</td><td>Not listed</td><td>Not listed</td></tr>
          </tbody>
        </table></div>
        <p class="muted">*Top of waistband to bottom of leg.</p>
        <p>Need a specific measurement that's not listed? Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> with the size you're considering and we'll measure a pair from inventory.</p>`,
      related: [
        { label: 'Size chart page', href: SRC.size, ext: true },
        { label: 'How to choose a size', href: '#a-choose-size' },
      ],
    },
    {
      id: 'a-women-sizes',
      cat: 'size',
      title: "Women's sizing help",
      summary: 'The published women’s table is incomplete. Reach out and we’ll match you to the right size from inventory.',
      body: `
        <p>Our public <a href="${SRC.size}" target="_blank" rel="noopener noreferrer">size chart page</a> lists a partial set of women's measurements without clearly labeled rows and columns. Rather than guess, we'd rather get it right.</p>
        <p>For women's sizing help:</p>
        <ul>
          <li>Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> with your chest and waist measurements, plus the item you're looking at.</li>
          <li>Or call <a href="tel:18009966939">800-996-6939</a> and our team can pull the right size from inventory.</li>
        </ul>
        <p>We're working with our product team to publish a complete, labeled women's chart — until then, a quick email is the fastest path to a great fit.</p>`,
      related: [
        { label: 'Contact support', href: '#contact' },
        { label: 'Size chart page', href: SRC.size, ext: true },
      ],
    },

    // PRODUCT
    {
      id: 'a-cool-stretch',
      cat: 'product',
      title: 'What is Cool-Stretch performance fabric?',
      summary: 'Our signature performance fabric: moisture-wicking, quick-drying, with built-in stretch for a full swing.',
      body: `
        <p>Cool-Stretch is the performance fabric used across our golf polos, shirts, shorts, and pants. Features called out on our product pages include:</p>
        <ul>
          <li><strong>Moisture-wicking</strong> to pull sweat off your skin on hot rounds.</li>
          <li><strong>Quick-dry technology</strong> so you stay comfortable after a heavy backswing.</li>
          <li><strong>Stretch</strong> (some pieces are 4-way stretch) for unrestricted movement.</li>
        </ul>
        <p>Other materials in the line: <strong>genuine leather</strong> with ratchet-fit technology on our belts, <strong>stretch fabric with wind resistance and moisture control</strong> on the Tattoo Golf jacket, and <strong>Cool &amp; Dry</strong> moisture-wicking fabric on FlexFit visors.</p>`,
      related: [
        { label: 'Shop tattoogolf.com', href: 'https://tattoogolf.com', ext: true },
      ],
    },
    {
      id: 'a-care',
      cat: 'product',
      title: 'How should I wash and care for my Tattoo Golf gear?',
      summary: 'Specific wash, dry, and iron instructions are not published. Follow the care label on each garment.',
      body: `
        <p>Each Tattoo Golf piece ships with a care label sewn into the garment — <strong>follow the label first</strong> for the most accurate guidance.</p>
        <p>In general, performance polos with moisture-wicking fabric do best with cool wash and low heat. To preserve printed designs:</p>
        <ul>
          <li>Turn the garment inside out before washing.</li>
          <li>Skip fabric softener — it can clog moisture-wicking fibers.</li>
          <li>Air dry or tumble dry on low. Avoid hot dryers when possible.</li>
        </ul>
        <p>If your label is missing or unreadable, email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> and we'll confirm the manufacturer's instructions for your item.</p>`,
      related: [{ label: 'Contact support', href: '#contact' }],
    },
    {
      id: 'a-design',
      cat: 'product',
      title: 'What makes Tattoo Golf… Tattoo Golf?',
      summary: 'Bold, tattoo-inspired designs on premium performance apparel. Quality Beyond Par, since 1999.',
      body: `
        <p>We've been building bold, tattoo-inspired golf apparel since 1999. Every piece blends <strong>statement-making design</strong> with <strong>premium performance fabric</strong> — skulls, roses, and crossing clubs on shirts you'd actually want to wear off the course.</p>
        <ul>
          <li>Signature collections include <strong>Skull &amp; Roses</strong>, <strong>The Blade</strong> (couples matching polos), <strong>Aloha</strong>, and ongoing seasonal drops.</li>
          <li>Beyond polos, the line covers <strong>shorts, pants, hats, visors, belts, gloves, ball markers, and tees</strong>.</li>
        </ul>
        <p>Quality Beyond Par.</p>`,
      related: [{ label: 'Shop tattoogolf.com', href: 'https://tattoogolf.com', ext: true }],
    },

    // ACCOUNT
    {
      id: 'a-account-basics',
      cat: 'account',
      title: 'How do I view my orders or update my account?',
      summary: 'Log in to tattoogolf.com and open My Account → Complete Orders. Email us if you can’t access your account.',
      body: `
        <p>To see your order history or manage your account:</p>
        <ol>
          <li>Click <strong>Login</strong> at the top of tattoogolf.com.</li>
          <li>Open <code>My Account</code>.</li>
          <li>Choose <code>Complete Orders</code> to see past orders, tracking, and return options.</li>
        </ol>
        <p>Locked out or never received a reset email? Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> and we'll sort it out.</p>`,
      related: [{ label: 'Contact support', href: '#contact' }],
    },
    {
      id: 'a-rewards',
      cat: 'account',
      title: 'Do you have a rewards program?',
      summary: 'There’s a rewards program with points and discount codes referenced on the site. Email us for the current terms.',
      body: `
        <p>Our checkout and account flows reference a rewards program — phrases like “Join program to get rewards,” “Redeem your points for discounts,” and reward expiration dates appear once you're logged in.</p>
        <p>Because the program details aren't fully published on a single public page, we'd rather answer your specific question than guess. For the current point values, earning rules, and expiration timing:</p>
        <ul>
          <li>Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a>.</li>
          <li>Or call <a href="tel:18009966939">800-996-6939</a>.</li>
        </ul>`,
      related: [{ label: 'Contact support', href: '#contact' }],
    },
    {
      id: 'a-gift-cards',
      cat: 'account',
      title: 'How do gift certificates work?',
      summary: 'Available on tattoogolf.com. Gift certificates can’t be returned for a refund.',
      body: `
        <p>Gift certificates are available on tattoogolf.com and make a solid gift for any golfer who likes a little edge in their wardrobe.</p>
        <ul>
          <li>Apply the certificate code at checkout.</li>
          <li><strong>Returns:</strong> gift certificates themselves are not returnable.</li>
          <li>Items purchased with a gift certificate follow the standard <a href="${SRC.returns}" target="_blank" rel="noopener noreferrer">60-day return policy</a> unless they're from the Sales Rack (store credit only).</li>
        </ul>`,
      related: [{ label: 'Returns page', href: SRC.returns, ext: true }],
    },

    // WHOLESALE
    {
      id: 'a-wholesale',
      cat: 'wholesale',
      title: 'How do I carry Tattoo Golf in my shop or pro shop?',
      summary: 'Email sales@tattoogolf.com or call 800-996-6939 — our team handles wholesale and retail partnerships directly.',
      body: `
        <p>We work with pro shops, golf retailers, team stores, and boutique apparel shops who want to stock Tattoo Golf. To start a wholesale conversation:</p>
        <ul>
          <li>Email <a href="mailto:sales@tattoogolf.com">sales@tattoogolf.com</a> with your shop name, location, website, and what categories you're most interested in carrying.</li>
          <li>Or call <a href="tel:18009966939">800-996-6939</a>.</li>
        </ul>
        <p>We'll respond with current line sheets, minimum order details, and onboarding steps.</p>`,
      related: [{ label: 'Contact support', href: '#contact' }],
    },

    // PRIVACY / TERMS
    {
      id: 'a-privacy',
      cat: 'privacy',
      title: 'How do you handle my data and cookies?',
      summary: 'See our Privacy Policy for the full details. Our contact form is protected by hCaptcha.',
      body: `
        <p>Tattoo Golf collects standard e-commerce information — name, shipping address, email, and order history — to process and ship your orders. The contact form is protected by <strong>hCaptcha</strong>; the hCaptcha Privacy Policy and Terms of Service apply when you submit a message.</p>
        <ul>
          <li>Read the full <a href="${SRC.privacy}" target="_blank" rel="noopener noreferrer">Privacy Policy</a> for collection, use, and sharing details.</li>
          <li>Questions about your data? Email <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a>.</li>
        </ul>`,
      related: [
        { label: 'Privacy Policy', href: SRC.privacy, ext: true },
        { label: 'Terms of Service', href: SRC.terms, ext: true },
      ],
    },
    {
      id: 'a-terms',
      cat: 'privacy',
      title: 'Terms of Service and payment accuracy',
      summary: 'Read the Terms of Service for binding terms. You agree your payment details are accurate and authorized when you order.',
      body: `
        <p>Placing an order on tattoogolf.com means you agree to our <a href="${SRC.terms}" target="_blank" rel="noopener noreferrer">Terms of Service</a>, including that the payment information you provide is <strong>accurate, current, and authorized for use</strong>.</p>
        <p>If anything in your order looks off — wrong total, wrong shipping address, wrong item — contact us immediately at <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a> before it ships and we'll fix it.</p>`,
      related: [
        { label: 'Terms of Service', href: SRC.terms, ext: true },
        { label: 'Privacy Policy', href: SRC.privacy, ext: true },
      ],
    },

    // CONTACT
    {
      id: 'a-contact',
      cat: 'contact',
      title: 'How do I contact Tattoo Golf?',
      summary: 'Email info@tattoogolf.com, call 800-996-6939, or use the contact form. We’re in Burbank, CA.',
      body: `
        <p>The fastest paths:</p>
        <ul>
          <li><strong>Email:</strong> <a href="mailto:info@tattoogolf.com">info@tattoogolf.com</a></li>
          <li><strong>Phone:</strong> <a href="tel:18009966939">800-996-6939</a></li>
          <li><strong>Saturday delivery / wholesale:</strong> <a href="mailto:sales@tattoogolf.com">sales@tattoogolf.com</a></li>
          <li><strong>Contact form:</strong> <a href="${SRC.contact}" target="_blank" rel="noopener noreferrer">tattoogolf.com/pages/contact</a> — protected by hCaptcha.</li>
          <li><strong>Mailing address:</strong> 2829 N. Glenoaks Blvd., Suite 103, Burbank, CA 91504.</li>
        </ul>
        <p>Business hours aren't posted publicly — email any time and we'll reply on the next business day.</p>`,
      related: [
        { label: 'Contact page', href: SRC.contact, ext: true },
        { label: 'Talk to our team', href: '#contact' },
      ],
    },
  ];

  // ---------- Render ----------
  const $ = (s, p = root) => p.querySelector(s);
  const $$ = (s, p = root) => Array.from(p.querySelectorAll(s));

  function renderCategories() {
    const counts = ARTICLES.reduce((m, a) => (m[a.cat] = (m[a.cat] || 0) + 1, m), {});
    const grid = $('#cat-grid');
    grid.innerHTML = CATEGORIES.map(c => `
      <a class="cat-card" href="#articles" data-cat="${c.id}" role="listitem">
        <div class="cat-icon" aria-hidden="true">${c.icon}</div>
        <h3>${c.label}</h3>
        <p>${c.blurb}</p>
        <span class="cat-count">${counts[c.id] || 0} articles</span>
      </a>
    `).join('');
    $$('.cat-card', grid).forEach(card => {
      card.addEventListener('click', e => {
        const cat = card.getAttribute('data-cat');
        setActiveChip(cat);
        $('#q').value = '';
        toggleClear();
        applyFilter();
        // smooth scroll handled by anchor; ensure focus on results
        setTimeout(() => { $('#chips').scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 0);
      });
    });
  }

  function renderChips() {
    const chips = $('#chips');
    const all = `<button class="chip" data-cat="all" aria-pressed="true">All <span class="muted">(${ARTICLES.length})</span></button>`;
    const counts = ARTICLES.reduce((m, a) => (m[a.cat] = (m[a.cat] || 0) + 1, m), {});
    chips.innerHTML = all + CATEGORIES.map(c => `
      <button class="chip" data-cat="${c.id}" aria-pressed="false">${c.label} <span class="muted">(${counts[c.id] || 0})</span></button>
    `).join('');
    $$('.chip', chips).forEach(btn => {
      btn.addEventListener('click', () => {
        setActiveChip(btn.dataset.cat);
        applyFilter();
      });
    });
  }

  function setActiveChip(cat) {
    $$('.chip').forEach(c => c.setAttribute('aria-pressed', c.dataset.cat === cat ? 'true' : 'false'));
  }
  function activeChip() {
    return ($('.chip[aria-pressed="true"]') || {}).dataset?.cat || 'all';
  }

  function renderArticles(list) {
    const wrap = $('#article-list');
    if (!list.length) { wrap.innerHTML = ''; $('#empty').hidden = false; updateCount(0); return; }
    $('#empty').hidden = true;
    wrap.innerHTML = list.map(a => {
      const catLabel = (CATEGORIES.find(c => c.id === a.cat) || {}).label || '';
      const related = (a.related || []).map(r => {
        const ext = r.ext ? ' target="_blank" rel="noopener noreferrer"' : '';
        const arrow = r.ext ? ' <span aria-hidden="true">↗</span>' : '';
        return `<a href="${r.href}"${ext}>${r.label}${arrow}</a>`;
      }).join('');
      return `
        <details class="article" id="${a.id}">
          <summary>
            <div>
              <div class="article-meta"><span class="article-cat">${catLabel}</span></div>
              <div class="article-title">${a.title}</div>
              <div class="article-summary">${a.summary}</div>
            </div>
            <svg class="chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
          </summary>
          <div class="article-body">
            ${a.body}
            ${related ? `<div class="related-links">${related}</div>` : ''}
          </div>
        </details>
      `;
    }).join('');
    updateCount(list.length);
    applyHighlight();
  }

  function updateCount(n) {
    $('#count').textContent = `${n} ${n === 1 ? 'article' : 'articles'}`;
  }

  // ---------- Search & Filter ----------
  function strip(html) { return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' '); }

  let currentQuery = '';

  function applyFilter() {
    const cat = activeChip();
    const q = currentQuery.trim().toLowerCase();
    let list = ARTICLES.filter(a => cat === 'all' || a.cat === cat);
    if (q) {
      list = list.filter(a => {
        const hay = (a.title + ' ' + a.summary + ' ' + strip(a.body)).toLowerCase();
        return hay.includes(q);
      });
    }
    renderArticles(list);
  }

  function applyHighlight() {
    const q = currentQuery.trim();
    if (!q) return;
    const safe = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`(${safe})`, 'gi');
    $$('.article-title, .article-summary').forEach(el => {
      const txt = el.textContent;
      if (re.test(txt)) el.innerHTML = txt.replace(re, '<mark class="hl">$1</mark>');
    });
  }

  function toggleClear() {
    $('#clear-q').hidden = $('#q').value.length === 0;
  }

  // ---------- Theme ----------
  let selectedTheme = null;

  function initTheme() {
    const prefers = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    const theme = selectedTheme || prefers;
    root.dataset.theme = theme;
    if ($('#theme-toggle')) $('#theme-toggle').setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
  }
  function toggleTheme() {
    const next = root.dataset.theme === 'dark' ? 'light' : 'dark';
    selectedTheme = next;
    root.dataset.theme = next;
    if ($('#theme-toggle')) $('#theme-toggle').setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
  }

  // ---------- Notes dialog ----------
  function openDialog() {
    const d = $('#notes-dialog');
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
  }
  function closeDialog() {
    const d = $('#notes-dialog');
    if (d.close) d.close(); else d.removeAttribute('open');
  }

  // ---------- Bind ----------
  function bind() {
    $('#q').addEventListener('input', (e) => {
      currentQuery = e.target.value;
      toggleClear();
      applyFilter();
    });
    $('#clear-q').addEventListener('click', () => {
      $('#q').value = ''; currentQuery = ''; toggleClear(); applyFilter(); $('#q').focus();
    });
    if ($('#theme-toggle')) $('#theme-toggle').addEventListener('click', toggleTheme);
    if ($('#notes-btn')) $('#notes-btn').addEventListener('click', openDialog);
    if ($('#close-notes')) $('#close-notes').addEventListener('click', closeDialog);
    if ($('#close-notes-2')) $('#close-notes-2').addEventListener('click', closeDialog);
    if ($('#notes-dialog')) $('#notes-dialog').addEventListener('click', (e) => { if (e.target.id === 'notes-dialog') closeDialog(); });
    // Hash deep-linking to an article
    window.addEventListener('hashchange', openHash);
    openHash();
  }

  function openHash() {
    const id = location.hash.replace('#', '');
    if (!id) return;
    const el = root.querySelector('#' + id.replace(/[^A-Za-z0-9_-]/g, ''));
    if (el && el.tagName.toLowerCase() === 'details') {
      el.open = true;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ---------- Init ----------
  document.addEventListener('DOMContentLoaded', () => {
    initTheme();
    renderCategories();
    renderChips();
    renderArticles(ARTICLES);
    bind();
  });
})();
